import React from "react";
import PropTypes from "prop-types";
import { Card, Empty, Badge, Button } from "antd";
import { STATE_STATUS } from "constants/state-status";

import "styles/kan-ban-column.css";

class KanBanColumn extends React.Component {
    currentPage = 1;
    pageSize = 10;

    componentDidMount() {
        this.handleCasesFetch(this.props);
    }
    componentDidUpdate(prevProps) {
        this.handleCasesFetch(this.props);
        if (
            prevProps.count !== this.props.count &&
            this.props.status === STATE_STATUS.FETCHED
        ) {
            this.currentPage = 1;
            this.props.fetch(this.currentPage, this.pageSize, null);
        }
    }
    handleCasesFetch(props) {
        if (props.status === STATE_STATUS.UNFETCHED && props.count > 0) {
            props.fetch(this.currentPage, this.pageSize, null);
        }
    }
    loadMore = () => {
        if (this.props.fetchedCount + this.pageSize < this.props.count) {
            this.currentPage += 1;
            this.props.fetch(this.currentPage, this.pageSize, null);
        }
    };
    render() {
        const { title, children, count } = this.props;
        return (
            <div className={"kan-ban-column"}>
                <Card
                    title={title}
                    extra={[
                        <Badge
                            key={"case-count"}
                            // color={"#87d068"}
                            className={"badge-color"}
                            count={count}
                        />
                    ]}
                >
                    {children.length === 0 ? <Empty /> : children}
                    {this.props.count > 0 &&
                    this.props.fetchedCount > 0 &&
                    this.props.count > this.props.fetchedCount ? (
                            <div className={"d-flex justify-content-center"}>
                                <Button type={"link"} onClick={this.loadMore}>
                                Load more...
                                </Button>
                            </div>
                        ) : null}
                </Card>
            </div>
        );
    }
}

KanBanColumn.propTypes = {
    title: PropTypes.string,
    count: PropTypes.number,
    fetchedCount: PropTypes.number,
    fetch: PropTypes.func,
    status: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    extraContent: PropTypes.node
};

export default KanBanColumn;
